import png from '../assets/no-data.png';

export const NoData = ({ text }: { text?: string }) => {
  return (
    <div className="flex justify-center flex-col space-y-5">
      <img src={png} className="w-[150px]" />
      <p className="w-full text-center">{text ? text : 'Geen resultaten'}</p>
    </div>
  );
};
